import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PICKUP_STATUS } from 'domains/customer-shipment/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerShipmentPickupStatusBadge = ({ status }) => {

  const colorMap = {
    [PICKUP_STATUS.PENDING]   : 'warning',
    [PICKUP_STATUS.REQUESTED] : 'success',
    [PICKUP_STATUS.COMPLETED] : 'primary'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerShipmentPickupStatusBadge.propTypes = propTypes

export default CustomerShipmentPickupStatusBadge